import { actionType } from "../../helpers/reducers";

export const USER_SET = "user/SET";
export const USER_CLEAR = "user/CLEAR";

export const setUser = actionType(USER_SET);

// API
export const USER_CHK_AUTH = "user/CHK_AUTH";
export const USER_CHK_AUTH_STATUS = "user/CHK_AUTH_STATUS";
export const USER_CREATE = "user/CREATE";
export const USER_SAVE = "user/SAVE";
export const USER_LOGOUT = "user/LOGOUT";

export const checkAuth = actionType(USER_CHK_AUTH);
export const checkAuthStatus = actionType(USER_CHK_AUTH_STATUS);
export const createUser = actionType(USER_CREATE);
export const saveUser = actionType(USER_SAVE);
export const logoutUser = actionType(USER_LOGOUT);
